import React, { memo, useState } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from "react-simple-maps";
import geoUrl from "../world.json";

const markers = [
    {
    name: "Davinci Jets",
    address: `Charlotte Douglas International Airport (KCLT)<br />
   Charlotte, NC USA<br />
    +1 704.359.4674`,
    coordinates: [-80.92992, 35.21313],
    type: "installationCenter",
  },
  {
    name: "Prince Aviation",
    address: `Belgrade Nikola Tesla Airport (LYBE)<br />
    Beograd,  Serbia<br />
   +381 222097585`,
    coordinates: [20.40309, 44.82969],
    type: "installationCenter",
  },
  {
    name: "Toledo Jet",
    address: `Eugene R Kranz Toledo Express Airport (KTOL)<br />
    Swanton, OH USA<br />
    +1 419.866.9050`,
    coordinates: [-83.81935,  41.58822],
    type: "installationCenter",
  },
  {
    name: "Pulse Aero",
    address: `Adelaide Airport (YPAD)<br />
    Adelaide Airport, SA Australia<br />
   +61 8 8234 4023`,
    coordinates: [138.53286, -34.93679],
    type: "installationCenter",
  },
  {
    name: "Rheinland Air Service GmbH",
    address: `Mönchengladbach Airport (EDLN)<br />
    Möenchengladbach,  Germany<br />
    +49 2161 994 8100`,
    coordinates: [6.4957,  51.22879],
    type: "installationCenter",
  },
  {
    name: "Toledo Jet",
    address: `Fort Lauderdale Executive Airport (KFXE)<br />
    Ft. Lauderdale, FL USA<br />
    +1 954.491.3170`,
    coordinates: [-80.18685, 26.19932],
    type: "installationCenter",
  },
  {
    name: "ACI Jet",
    address: `San Luis Obispo Regional Airport  (KSBP)<br />
    San Luis Obispo, CA USA<br />
    +1 805.548.1337`,
    coordinates: [-120.63535, 35.23658],
    type: "serviceCenter",
  },
  {
    name: "ASG Aerospace",
    address: `Miami Executive Airport (KTMB)<br />
    Miami, FL USA<br />
    +1 305.253.0802`,
    coordinates: [-80.41922, 25.64615],
    type: "serviceCenter",
  },
  {
    name: "Atlas Air Service AG",
    address: `Bremen Airport (EDDW)<br />
    Bremen, Germany<br />
    +49 4215 365 8760`,
    coordinates: [8.77857, 53.05441],
    type: "serviceCenter",
  },
  {
    name: "Rose Aircraft Services, Inc",
    address: `Mena Intermountain Mun. Airport (KMEZ)<br />
    Mena, AR USA<br />
    +1 479.394.2551`,
    coordinates: [-94.20727, 34.55408],
    type: "serviceCenter",
  },
  {
    name: "SoCal Jet Services",
    address: `Long Beach Airport (KLGB)<br />
    Long Beach, CA USA<br />
    +1 562.490.9777`,
    coordinates: [-118.15287, 33.81167],
    type: "serviceCenter",
  },
  {
    name: "Western Aircraft",
    address: `Boise Airport (KBOI)<br />
    Boise, ID USA<br />
    +1 800.333.3442`,
    coordinates: [-116.21744, 43.56094],
    type: "serviceCenter",
  },
{
    name: "Bromma Air Maintenance AB",
    address: `Bromma Airport (ESSB)<br />
    Bromma, Sweden<br />
   +46 8 5661 9000`,
    coordinates: [17.94259, 59.35473],
    type: "serviceCenter",
  },
 {
    name: "Conal",
    address: `Sorocaba Airport (SDCO)<br />
    Sorocaba – SP, Brazil<br />
    +55 15 3313 9500`,
    coordinates: [-47.4824, -23.48406],
    type: "serviceCenter",
  },
  {
    name: "Burlington Air Center, Inc.",
    address: `Burlington Municipal Airport (KBUU)<br />
    Burlington, WI USA<br />
    +1 262.763.9500`,
    coordinates: [-88.30388, 42.69204],
    type: "serviceCenter",
  },
  {
    name: "Fly ASG Limited",
    address: `Guernsey International Airport (EGJB)<br />
    Guernsey, Channel Islands<br />
    +44 1481 265750`,
    coordinates: [-2.60024, 49.43124],
    type: "serviceCenter",
  },
  {
    name: "GA Jet Mx",
    address: `Gwinnet County Airport - Brisco Field (KLZU)<br />
    Lawrenceville, GA USA<br />
    +1 855.513.4526`,
    coordinates: [-83.96391, 33.97495],
    type: "serviceCenter",
  },
  {
    name: "Signature Technicair EMEA",
    address: `Bournemouth Airport (EGHH)<br />
    Christchurch, Dorset UK<br />
    +44 1202 573243`,
    coordinates: [-1.8462, 50.78349],
    type: "serviceCenter",
  },
  {
    name: "Solojet Aviação",
    address: `Chacara Aeroporto (SBJD)<br />
    Jundiai – SP, Brazil<br />
    +55 11 4582 7899`,
    coordinates: [-46.94485, -23.17542],
    type: "serviceCenter",
  },
  {
    name: "Tamarack Transformation Center",
    address: `Sandpoint Airport (KSZT)<br />
    Sandpoint, ID USA<br />
    +1 208.255.4400`,
    coordinates: [-116.56282, 48.29314],
    type: "transformationCenter",
  },
  {
    name: "Aero Store Aviation Ltda",
    address: `Sorocaba Airport (SDCO)<br />
    Sorocaba, SP Brazil<br />
    +1 55 15 3327-9666`,
    coordinates: [-47.482408, -23.485897],
    type: "installationCenter",
  },];

const MapChart = ({ setTooltipContent }) => {
  const rootEl = document.getElementById("root");
  const defaultFilter = rootEl.getAttribute("data-show");
  const showFilterControls = JSON.parse(
    rootEl.getAttribute("data-showFilterControls")
  );
  const [zoom, setZoom] = useState(1);
  const [center, setCenter] = useState([0, 0]);
  const [filter, setFilter] = useState(defaultFilter ? defaultFilter : "");

  const markersToFilter = markers.filter((marker) => {
    if (marker.type === filter) return marker;

    if (filter === "") return marker;

    return "";
  });

  return (
    <div className="map--container">
      {showFilterControls && (
        <ul className="map--filters">
          <li>
            <button
              type="button"
              className={filter === "" ? "active" : ""}
              onClick={() => setFilter("")}
            >
              All
            </button>
          </li>
          <li>
            <button
              type="button"
              className={filter === "transformationCenter" ? "active" : ""}
              onClick={() =>
                filter === "transformationCenter"
                  ? setFilter("")
                  : setFilter("transformationCenter")
              }
            >
              Transformation Centers
            </button>
          </li>
         <li>
            <button
              type="button"
              className={filter === "installationCenter" ? "active" : ""}
              onClick={() =>
                filter === "installationCenter"
                  ? setFilter("")
                  : setFilter("installationCenter")
              }
            >
              Installation Centers
            </button>
          </li>
          <li>
            <button
              type="button"
              className={filter === "serviceCenter" ? "active" : ""}
              onClick={() =>
                filter === "serviceCenter"
                  ? setFilter("")
                  : setFilter("serviceCenter")
              }
            >
              Service Centers
            </button>
          </li>
        </ul>
      )}
      <ul className="map--controls">
        <li>
          <button type="button" onClick={() => setZoom((prev) => prev + 0.25)}>
            <svg
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M38.252 20.124C38.2524 23.7092 37.1896 27.2139 35.1981 30.195C33.2065 33.1761 30.3756 35.4997 27.0635 36.8719C23.7513 38.244 20.1066 38.6031 16.5903 37.9038C13.074 37.2045 9.84408 35.4781 7.30899 32.943C4.7739 30.4079 3.04753 27.178 2.3482 23.6617C1.64886 20.1454 2.00799 16.5007 3.38015 13.1886C4.75231 9.87638 7.07588 7.04551 10.057 5.05395C13.0381 3.06239 16.5429 1.9996 20.128 2C24.9346 2.00053 29.5442 3.91019 32.943 7.30898C36.3418 10.7078 38.2515 15.3174 38.252 20.124Z"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.002 20H29.002"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.002 29V11"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M32.944 32.94L47.002 47"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </li>
        <li>
          <button type="button" onClick={() => setZoom((prev) => prev - 0.25)}>
            <svg
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M38.252 20.124C38.2524 23.7091 37.1897 27.2137 35.1982 30.1948C33.2067 33.1759 30.376 35.4994 27.0639 36.8717C23.7519 38.2439 20.1073 38.6031 16.591 37.904C13.0748 37.2048 9.84486 35.4786 7.3097 32.9437C4.77453 30.4088 3.048 27.1791 2.34844 23.6629C1.64888 20.1468 2.00772 16.5022 3.37958 13.1899C4.75143 9.87773 7.07469 7.04672 10.0555 5.05492C13.0364 3.06312 16.5409 2 20.126 2C24.933 2 29.5431 3.90942 32.9423 7.30828C36.3415 10.7071 38.2515 15.317 38.252 20.124V20.124Z"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.002 20H29.002"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M32.944 32.94L47.002 47"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </li>
        {zoom !== 1 && (
          <li>
            <button
              type="button"
              onClick={() => {
                setZoom(1);
                setCenter([0, 0]);
              }}
            >
              <svg
                width="46"
                height="43"
                viewBox="0 0 46 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 25.9832V34.9832H2"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.434 34.9892C7.33992 31.7545 5.45247 27.5542 5.08833 23.0928C4.72419 18.6315 5.90551 14.1807 8.43409 10.4871C10.9627 6.79354 14.6846 4.08201 18.9755 2.80746C23.2664 1.53292 27.8651 1.77291 32 3.48717"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.424 34.9792C7.09949 31.5046 5.18081 26.9211 5.03868 22.1143C4.89656 17.3075 6.54107 12.6187 9.65448 8.95372C12.7679 5.28876 17.1292 2.90783 21.8957 2.27098C26.6622 1.63413 31.4956 2.78656 35.462 5.5056C39.4283 8.22463 42.2461 12.3173 43.3709 16.9928C44.4957 21.6682 43.8477 26.5947 41.552 30.8202C39.2563 35.0457 35.4759 38.2704 30.9413 39.8711C26.4066 41.4719 21.4396 41.3351 17 39.4872"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </li>
        )}
      </ul>
      <ComposableMap 
        data-tip=""
        width={800}
        height={600}
        projectionConfig={{
          scale: 160,
          center: [0, 0]
        }}
      >
        <ZoomableGroup
          zoom={zoom}
          center={center}
          style={{ transition: "all 100ms ease" }}
          maxZoom={1}
        >
          <Geographies
            geography={geoUrl}
            onClick={(e) => {
              setZoom(1);
              setCenter([0, 0]);
            }}
          >
            {({ geographies }) =>
              geographies.map((geo) => {
                let countries = [
                  "United States of America",
                  "United Kingdom",
                  "Canada",
                  "Mexico",
                  "Brazil",
                  "Australia",
                  "France",
                  "Germany",
                  "Italy",
                  "Finland",
                  "Romania",
                  "Bulgaria",
                  "Spain",
                  "Portugal",
                  "Ireland",
                  "Norway",
                  "Sweden",
                  "Austria",
                  "Netherlands",
                  "Bosnia and Herz.",
                  "Serbia",
                  "Switzerland",
                  "Greece",
                  "Herzegovina",
                  "Croatia",
                  "Slovenia",
                  "Czechia",
                  "Albania",
                  "Belgium",
                  "Luxembourg",
                  "Switzerland",
                  "Kosovo",
                  "Estonia",
                  "Latvia",
                  "Poland",
                  "Liechtenstein",
                  "Montenegro",
                  "Hungary",
                  "Macedonia",
                  "Amsterdam",
                  "Bulgaria",
                  "Romania",
                  "Slovakia",
                ];
                let shouldColor = countries.some(() =>
                  countries.includes(geo.properties.NAME)
                );
                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={shouldColor ? "#2392D0" : "#EAEAEC"}
                    stroke={shouldColor ? "#2392D0" : "#EAEAEC"}
                  />
                );
              })
            }
          </Geographies>
          {markersToFilter.map(
            ({ name, coordinates, type, address }, index) => (
              <Marker
                key={index}
                coordinates={coordinates}
                onClick={() => {
                  setZoom(2.5);
                  setCenter(coordinates);
                }}
                onMouseEnter={() => {
                  setTooltipContent(
                    `<div class="map--tooltip"><h3>${name}</h3><address>${address}</address></div>`
                  );
                }}
                onMouseLeave={() => {
                  setTooltipContent("");
                }}
              >
                <path
                  transform="translate(-10.5,-32.0981)"
                  d="M10.5 0.917603C5.1141 0.917603 0.75 5.26415 0.75 10.6481C0.75 19.9574 10.5 32.0981 10.5 32.0981C10.5 32.0981 20.25 19.9555 20.25 10.6481C20.25 5.2661 15.8859 0.917603 10.5 0.917603ZM10.5 16.0321C9.10364 16.0321 7.76446 15.4774 6.77708 14.49C5.7897 13.5026 5.235 12.1634 5.235 10.7671C5.235 9.37069 5.7897 8.03151 6.77708 7.04414C7.76446 6.05676 9.10364 5.50205 10.5 5.50205C11.8964 5.50205 13.2355 6.05676 14.2229 7.04414C15.2103 8.03151 15.765 9.37069 15.765 10.7671C15.765 12.1634 15.2103 13.5026 14.2229 14.49C13.2355 15.4774 11.8964 16.0321 10.5 16.0321Z"
                  style={{ opacity: 0.8 }}
                  fill={type === "installationCenter" ? "#0D374F" : "#176490"}
                />
              </Marker>
            )
          )}
        </ZoomableGroup>
      </ComposableMap>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .rsm-geographies,
            .rsm-geography {
              outline: none;
              border: none;
            }


            path:focus-visible,
            path:focus {
              outline: none;
              border-color: inherit;
              -webkit-box-shadow: none;
              box-shadow: none;
            }`,
        }}
      />
    </div>
  );
};

export default memo(MapChart);
